// theme constant
export const gridSpacing = 2;
export const drawerWidth = 260;
export const drawerWidthClose = 85;
export const appDrawerWidth = 320;

export const APP_REQUEST_STATUS = {
    EN_PROCESO: '3f2eae4c-11e9-4edf-86f7-04f6bb6fddf6',
    PENDIENTE: '1ba55dc8-3d0a-4c09-933e-7b5aabc70d60',
    CANCELADO: '217aeef5-2957-4a87-bfa8-8a6e65ed0737',
    ENTREGADO: '4d43c52b-7858-4156-a537-d41d092c3399',
    PENDIENTE_APROBACION: '4dabb637-f9f3-43d9-bfc8-f95f17450e17'
}

export const APP_REQUEST_STATUS_DEVOLUCCION = {
    EN_PROCESO: 'ff7535f6-3274-4ab8-9976-5a45109048db',
    PROGRAMADO: 'ff7535f6-3274-4ab8-9972-5a45109048db',
    ENTREGA_PARCIAL: 'ff7535f6-3274-4ab8-9977-5a45109048db',
    CANCELADO: 'ff7535f6-3274-4ab8-9974-5a45109048db',
    ENTREGADO: 'ff7535f6-3274-4ab8-9975-5a45109048db'
}

export const APP_EVAL_STATUS = {
    EVALUADO: 'ff7535f4-3276-4ab8-9976-5a45109048dt',
    PENDIENTE: 'ff7535f6-3275-4ab8-9976-5a45109048dt',
    EN_PROCESO: 'ff7535f6-3276-4ab8-9976-5a45109048dt'
}

export const STATUS_TRANSFER_WAREHOUSE = {
    EN_TRANSITO: '57d4ff72-88d4-4273-9e35-45ef33adf2d4',
    FINALIZADO: '57d81b0a-7c7c-4772-9174-efdc7df128df'
}

export const STATUS_TIPO_DOCUMENTO = {
    DNI: '1',
    RUC: '6'
}

export const STATUS_RELEVO = {
    ACTIVO: 'f5d6740c-0012-4595-97f5-9beaac0f26ce',
    INACTIVO: 'a22315a9-c623-4e0d-9bf7-2fb66d8c6820',
    PENDIENTE: 'e5ce373f-b91e-4fcc-8f92-eccfd1e7ed26'
}

export const COLOR_SOLICITUDES_TRANSFERECIAS = {
    PENDIENTE_PROGRAMAR: '#FF455C',
    CANCELADO: '#D2D2D2',
    PROCESO: '#FFB239',
    ENTREGADO: '#18C073',
    PENDIENTE_APROBACION: '#471DF3'
}

export const STATUS_ENTREGA_SOLICITUDES = {
    PROGRAMADO: '96cf2544-a507-4ff1-b7b1-174a1e158dd0',
    ENTREGADO: '97cf2544-a507-4ff1-b7b1-174a1e158dd0',
    CANCELADO: '75cf2544-a507-4ff1-b7b1-174a1e158dd0'
}